module.exports = __webpack_public_path__ + "img/logo-twitter.b2108ea5.svg";